import React, { useState, useEffect } from "react";
import { DrawerContent } from "../components/molecules/DrawerContent";
import SearchBar from "../components/molecules/SearchBar";
import { useSearch } from "../context/SearchContext";
import CloseDrawerIcon from "../assets/CloseDrawerIcon";

const SearchPage: React.FC = () => {
  const {
    handleSearch,
    products,
    contextReceived,
    isWaitingForContext,
    setIsWaitingForContext,
    handleProductosPreaprobadosClick,
  } = useSearch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerType, setDrawerType] = useState<"questions" | "user_products">(
    "questions",
  );

  const handleMoreQuestionsClick = () => {
    setDrawerType("questions");
    setIsDrawerOpen(true);
  };

  useEffect(() => {
    if (isWaitingForContext && contextReceived && products.length > 0) {
      setIsWaitingForContext(false);
      handleProductosPreaprobadosClick("initial", "menu");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextReceived]);

  return (
    <div className="flex flex-col items-center justify-center w-full relative">
      <div className="flex flex-col items-center max-w-[1200px] w-full h-screen sm:h-full mx-auto">
        <div className="space-y-4 px-5 w-full">
          <div className="max-w-[680px] mx-auto">
            <SearchBar
              queryDisplayMode="searchPage"
              isInternalSearch={false}
              onMoreQuestionsClick={handleMoreQuestionsClick}
              onProductosPreaprobadosClick={() =>
                handleProductosPreaprobadosClick("initial", "menu")
              }
            />
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsDrawerOpen(false)}
        />
      )}

      {/* Desktop Drawer */}
      <div
        className={`fixed top-0 right-0 md:w-[80%] xl:w-[40%] h-full 
          bg-white shadow-lg transition-transform duration-300 ease-in-out z-50 transform
          ${isDrawerOpen ? "translate-x-0" : "translate-x-full"}
          hidden md:block
        `}
      >
        <div className="w-full h-full overflow-y-auto relative">
          <button
            onClick={() => setIsDrawerOpen(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 z-10"
            aria-label="Close drawer"
          >
            <CloseDrawerIcon className="w-8 h-8" />
          </button>
          <div className="px-6 py-10">
            <DrawerContent
              type={drawerType}
              onOptionClick={function (option: string): void {
                handleSearch(option, "initial", "drawer");
                setIsDrawerOpen(false);
              }}
            />
          </div>
        </div>
      </div>

      <div
        className={`fixed bottom-0 right-0 w-full h-[90%] 
          bg-white shadow-lg transition-transform duration-300 ease-in-out z-50 transform
          ${isDrawerOpen ? "translate-y-0" : "translate-y-full"}
          rounded-t-[20px] md:hidden
        `}
      >
        <div className="w-full h-full overflow-y-auto relative">
          <div className="h-[4px] w-[36px] rounded-full mx-auto mt-3 mb-4" />
          <button
            onClick={() => setIsDrawerOpen(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 z-10"
            aria-label="Close drawer"
          >
            <CloseDrawerIcon className="w-8 h-8" />
          </button>
          <div className="px-6 py-4">
            <DrawerContent
              type={drawerType}
              onOptionClick={function (option: string): void {
                handleSearch(option, "initial", "drawer");
                setIsDrawerOpen(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
